import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { LuCopyCheck, LuCopy } from 'react-icons/lu'
import { stMob } from './styles'

export default function CopyAndPaste({ text }) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    var textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand('copy')

      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      //console.error('Failed to copy: ', err)
    }
    document.body.removeChild(textarea)
  }

  return (
    <Box sx={stMob.containCopyAndPaste} onClick={handleCopy}>
      <Typography variant='body1' sx={stMob.textCopyAndPaste}>
        {text}
      </Typography>
      {copied ? (
        <LuCopyCheck color={'#4caf50'} size={25} style={{ marginLeft: '5px' }} />
      ) : (
        <LuCopy color={'#ff7043'} size={25} style={{ marginLeft: '5px' }} />
      )}
    </Box>
  )
}
